// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"op_a bho_qt bho_a bho_w","FaqAskQuestion__outdated":"op_b bho_vr bho_xg"};